module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-17-ef0371f29d6c0f86dc880c77a12283ad.png";